import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getStoredUser } from '../services';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Protects routes that require auth. Auth lives in an HTTP-only cookie that JS
 * can't read, so we use the stored user as the client-side marker. If the
 * cookie is missing/expired, the next API call returns 401 and the caller
 * clears state / redirects.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const user = getStoredUser();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
